export default "__VITE_ASSET__DWTvZLUK__"